import { ProductCardType } from '@/constants'
import type { Product, PromotionProductCarousel } from '@/types'
import { getTranslate } from '@/utils/api-interceptors'
import Link from 'next/link'
import { useEffect, useRef, useState } from 'react'
import ImageOptimize from '../ImageOptimize'
import ProductCard from '../ProductCard'

type ProductTabProps = {
  data: PromotionProductCarousel[]
}
const ProductTab = (tabData: ProductTabProps) => {
  const [activeIndex, setActiveIndex] = useState(0)

  const tabRef = useRef<HTMLDivElement>(null)
  const contentRef = useRef<HTMLDivElement>(null)
  const [isSticky, setIsSticky] = useState(false)
  const [offsetTop, setOffsetTop] = useState(0)
  const [height, setHeight] = useState(0)

  useEffect(() => {
    setTimeout(() => {
      if (contentRef.current) {
        const h = contentRef.current.getBoundingClientRect().height
        setHeight(h)
        if (tabRef.current) {
          const top =
            tabRef.current.getBoundingClientRect().top + window.scrollY
          setOffsetTop(top)
        }
      }
    }, 1000)
  }, [activeIndex])

  useEffect(() => {
    const handleScroll = () => {
      const scrollY = window.scrollY
      setIsSticky(
        scrollY >= offsetTop - 80 && scrollY < offsetTop - 180 + height
      )
    }
    window.addEventListener('scroll', handleScroll)
    return () => window.removeEventListener('scroll', handleScroll)
  }, [offsetTop])

  return (
    <section className='mb-3'>
      <div className='mb-3'>
        <h2 className='font-bold text-lg px-2'>Ưu đãi dành cho bạn</h2>
      </div>
      {tabData.data.length > 0 && (
        <>
          <div className='tab-home-cat block w-full '>
            <div
              ref={tabRef}
              className={`flex bg-white transition-all duration-300  ${
                isSticky ? 'fixed top-[67px] z-[9999] shadow-sm' : ''
              }`}
            >
              <div className='max-w-screen-xl overflow-hidden'>
                <div className='overflow-x-auto w-full scrollbar-hide'>
                  <ul className='flex w-max'>
                    {tabData.data.map((item, i) => (
                      <li
                        key={`item-b-${i}`}
                        className={`whitespace-nowrap flex items-center justify-center h-[52px] border-r border-[#F3F4F6] border-b  p-2 ${
                          activeIndex === i
                            ? 'bg-red-50 border-b-red-500 border-b-2'
                            : ''
                        }`}
                        onClick={() => setActiveIndex(i)}
                      >
                        {item?.customization &&
                        item?.customization?.thumbnail ? (
                          <span>
                            <ImageOptimize
                              src={item?.customization?.thumbnail}
                              alt={getTranslate(item?.name)}
                              width={100}
                              height={44}
                              loading='lazy'
                              className={`w-full h-auto`}
                            />
                          </span>
                        ) : (
                          <span
                            className={`block text-[#000] ${
                              activeIndex === i ? 'font-semibold' : ''
                            }`}
                          >
                            {getTranslate(item?.name)}
                          </span>
                        )}
                      </li>
                    ))}
                  </ul>
                </div>
              </div>
            </div>

            {tabData.data.map(
              (item, i) =>
                activeIndex === i && (
                  <div
                    key={`item-c-${i}`}
                    className='tab-content'
                    ref={contentRef}
                  >
                    {item?.customization && item?.customization?.banner ? (
                      <div className='px-2 py-4'>
                        <ImageOptimize
                          src={item?.customization?.banner}
                          alt={getTranslate(item?.name)}
                          width={412}
                          height={44}
                          loading='lazy'
                          className={`w-full h-auto`}
                        />
                      </div>
                    ) : (
                      <div className='px-2 py-4'>
                        <ImageOptimize
                          src={'/banner-cat-tab.png'}
                          alt={getTranslate(item?.name)}
                          width={412}
                          height={44}
                          loading='lazy'
                          className={`w-full h-auto`}
                        />
                      </div>
                    )}

                    <div className='max-w-screen grid grid-cols-2 gap-2 px-2'>
                      {item?.products &&
                        item?.products.length > 0 &&
                        item?.products
                          .slice(0, 10)
                          .map((product: Product, idx: number) => (
                            <ProductCard
                              key={product._id + idx + 'fs'}
                              product={product}
                              type={
                                product.flashSale
                                  ? ProductCardType.FLASH_SALE
                                  : ProductCardType.PRODUCT_CARD
                              }
                              layout={2}
                              className=''
                            />
                          ))}
                    </div>

                    <div className='py-4'>
                      <Link
                        href={item?.customization?.viewMoreLink}
                        className='text-mainBody text-center font-bold text-redPico overflow-hidden h-6 leading-6 block'
                        style={{
                          backgroundColor:
                            item?.customization?.viewMoreButtonColor,
                          color: item?.customization?.viewMoreColor,
                        }}
                      >
                        {`Xem thêm sản phẩm >>>`}
                      </Link>
                    </div>
                  </div>
                )
            )}
          </div>
        </>
      )}
    </section>
  )
}
export default ProductTab
